import Axios from "axios";
import { apiConfig } from "../constants/apiConfig";
import keyCloakApiService from "../helper/key-cloack-service";


const baseURL = `${apiConfig.siteUrl}/`;

class APIService {
  private axiosInstance: any;

  onUnAuthorize() {
    localStorage.clear();
    sessionStorage.clear();
    alert("Session Expired! Please login again")
    window.location.href = '/Login'
  }

  constructor() {
    this.axiosInstance = Axios.create({});

    this.axiosInstance.interceptors.response.use(
      (response: any) => {
        if (response.status === 401) {
          this.onUnAuthorize();
        }
        return response;
      },
      async (error: any) => {
        const originalRequest = error.config;
        if (error?.response?.status === 401 && !originalRequest._retry) {
          originalRequest._retry = true;

          let data = await keyCloakApiService.refreshToken();
          if (data && data.data && data.data.access_token) {

            // Update the authorization header with the new token
            originalRequest.headers["Authorization"] = "Bearer " + data.data.access_token;

            // Retry the original request with the updated token
            return this.axiosInstance(originalRequest);
          }
          else{
            this.onUnAuthorize();
          }

        }

        // If it's not a 401 or retry has already failed, reject the promise
        return Promise.reject(error);
      }
    );
  }


  getConfig = () => {
    let token = localStorage.getItem("token");
    if (token) {
      return {
        headers: {
          Authorization: "Bearer " + token,
        },
      };
    } else {
      return null;
    }
  };

  get = (url: string, additionalConfigs?: object) => {
    console.log(baseURL + url);
    return this.axiosInstance.get(baseURL + url, {
      ...this.getConfig(),
      ...additionalConfigs,
    });
  };

  post = (url: string, data = {}, additionalConfigs?: object) => {
    return this.axiosInstance.post(baseURL + url, data, {
      ...this.getConfig(),
      ...additionalConfigs,
    });
  };

  put = (url: string, data = {}) => {
    return this.axiosInstance.put(baseURL + url, data, this.getConfig());
  };

  patch = (url: string, data = {}) => {
    return this.axiosInstance.patch(baseURL + url, data, this.getConfig());
  };

  delete = (url: string, data = {}) => {
    return this.axiosInstance.delete(baseURL + url, this.getConfig());
  };

  postFormData = async (url: string, formData: FormData) => {
    let formHeaders = {
      ...this.getConfig()?.headers,
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
    };
    const options = {
      url: url,
      method: "POST",
      headers: formHeaders,
    };
    return await this.axiosInstance.post(baseURL + url, formData, options);
  };
}

export default new APIService();
